import {Injectable} from '@angular/core';
import {BackendResponse} from '@common/core/types/backend-response';
import { AbuseReportReason, AbuseReport } from './abuse-report';
import {PaginatedBackendResponse} from '@common/core/types/pagination/paginated-backend-response';
import {AppHttpClient} from '@common/core/http/app-http-client.service';

export interface AbuseReportService {
    totalClicks: number;
    clicks: {label: string; count: number}[];
    browsers: {label: string; count: number}[];
    locations: {
        label: string;
        code: string;
        percentage: number;
        count: number;
    }[];
    devices: {label: string; count: number}[];
    platforms: {label: string; count: number}[];
    referrers: {label: string; count: number}[];
    startDate: string;
    endDate: string;
}

export interface CreateAbuseReportPayload extends Partial<AbuseReport> {
    reason: AbuseReportReason;
    link: string;
}

@Injectable({
    providedIn: 'root',
})

export class AbuseReportService {
    static BASE_URI = 'abuse-reports';
    constructor(private http: AppHttpClient) {}

    create(params: CreateAbuseReportPayload): BackendResponse<{AbuseReport: AbuseReport}> {
        return this.http.post(AbuseReportService.BASE_URI, params);
    }

    index(
        params: {
            query?: string;
            per_page?: number;
        } = {}
    ): PaginatedBackendResponse<AbuseReport> {
        return this.http.get(`${AbuseReportService.BASE_URI}`, params);
    }

    delete(ids: number[]): BackendResponse<void> {
        return this.http.delete(`${AbuseReportService.BASE_URI}/${ids}`);
    }

    deleteLinks(ids: number[]): BackendResponse<void> {
        return this.http.delete(`${AbuseReportService.BASE_URI}/${ids}/links`);
    }

    deleteUsers(ids: number[]): BackendResponse<void> {
        return this.http.delete(`${AbuseReportService.BASE_URI}/${ids}/users`);
    }
}
